export var DEFAULT_LABEL = 'Learn More';